export default __webpack_public_path__ + "static/logo-soundr-05b96cba36b3ad90133d55b63b53701f.png";